export const NOT_FOUND_PAGE_CONTENT = {
    notFound: {
        title: 'Такой страницы нет',
        descriptionText: 'Роботы искали, люди искали, даже кот разработчика посмотрел - ничего.',
        descriptionSubText: 'Давайте вернемся на главную и попробуем снова.',
        buttonAriaLabel: 'Переход на главную страницу',
    },
    error: {
        title: 'Что-то пошло не так',
        descriptionText: 'Разработчики уже в курсе и вооружены виртуальными гаечными ключами.',
        descriptionSubText: 'Переходим на главную, там спокойнее.',
        buttonAriaLabel: 'Переход на главную страницу',
    },
};
